/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.6.26",
    versionName: "0.2.0-nightly.2025.6.26",
    versionChannel: "nightly",
    buildDate: "2025-06-26T00:09:57.381Z",
    commitHash: "a101a18974ab3e9392d86d88c51d983051c028a7",
};
